import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import { MediaProvider } from "@/context/MediaContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import EditModeBanner from "@/components/EditModeBanner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import AboutAims from "@/pages/AboutAims";
import Team from "@/pages/Team";
import Work from "@/pages/Work";
import Partners from "@/pages/Partners";
import GetInvolved from "@/pages/GetInvolved";
import News from "@/pages/News";
import NewsPost from "@/pages/NewsPost";
import Contact from "@/pages/Contact";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Hire from "@/pages/Hire";
import PrideLayout from "@/pages/pride/PrideLayout";
import PrideHome from "@/pages/pride/PrideHome";
import PrideWhatsOn from "@/pages/pride/PrideWhatsOn";
import PrideLineup from "@/pages/pride/PrideLineup";
import PrideParade from "@/pages/pride/PrideParade";
import PrideVisit from "@/pages/pride/PrideVisit";
import PrideContact from "@/pages/pride/PrideContact";
import WhitehavenWeekender from "@/pages/WhitehavenWeekender";
import EnergyCoastLive from "@/pages/EnergyCoastLive";
import Yaz from "@/pages/Yaz";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Login from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import AdminEvents from "@/pages/admin/AdminEvents";
import AdminNews from "@/pages/admin/AdminNews";
import AdminEquipment from "@/pages/admin/AdminEquipment";
import AdminEquipmentDetail from "@/pages/admin/AdminEquipmentDetail";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";
import AdminSubmissions from "@/pages/admin/AdminSubmissions";
import AdminBookings from "@/pages/admin/AdminBookings";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Layout({ children }) {
  return (
    <div className="site-dark">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ContentProvider>
          <MediaProvider>
          <SmoothScroll>
            <ScrollToTop />
            <Toaster position="top-center" richColors />
            <EditModeBanner />
            <Routes>
              <Route path="/" element={<Layout><Home /></Layout>} />
              <Route path="/about" element={<Layout><About /></Layout>} />
              <Route path="/about/aims" element={<Layout><AboutAims /></Layout>} />
              <Route path="/about/values" element={<Navigate to="/about/aims" replace />} />
              <Route path="/about/team" element={<Layout><Team /></Layout>} />
              <Route path="/work" element={<Layout><Work /></Layout>} />
              <Route path="/events" element={<Layout><Events /></Layout>} />
              <Route path="/events/:slug" element={<Layout><EventDetail /></Layout>} />
              <Route path="/hire" element={<Layout><Hire /></Layout>} />
              <Route path="/pride" element={<Layout><PrideLayout /></Layout>}>
                <Route index element={<PrideHome />} />
                <Route path="whats-on" element={<PrideWhatsOn />} />
                <Route path="lineup" element={<PrideLineup />} />
                <Route path="parade" element={<PrideParade />} />
                <Route path="visit" element={<PrideVisit />} />
                <Route path="contact" element={<PrideContact />} />
              </Route>
              <Route path="/ww" element={<Layout><WhitehavenWeekender /></Layout>} />
              <Route path="/ecl" element={<Layout><EnergyCoastLive /></Layout>} />
              <Route path="/yaz" element={<Layout><Yaz /></Layout>} />
              <Route path="/partners" element={<Layout><Partners /></Layout>} />
              <Route path="/get-involved" element={<Layout><GetInvolved /></Layout>} />
              <Route path="/donate" element={<Navigate to="/partners#donate" replace />} />
              <Route path="/news" element={<Layout><News /></Layout>} />
              <Route path="/news/:slug" element={<Layout><NewsPost /></Layout>} />
              <Route path="/contact" element={<Layout><Contact /></Layout>} />
              <Route path="/payment/success" element={<PaymentSuccess />} />

              <Route path="/admin/login" element={<Login />} />
              <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                <Route index element={<Dashboard />} />
                <Route path="events" element={<AdminEvents />} />
                <Route path="news" element={<AdminNews />} />
                <Route path="equipment" element={<AdminEquipment />} />
                <Route path="equipment/:id" element={<AdminEquipmentDetail />} />
                <Route path="enquiries" element={<AdminEnquiries />} />
                <Route path="submissions" element={<AdminSubmissions />} />
                <Route path="bookings" element={<AdminBookings />} />
              </Route>
            </Routes>
          </SmoothScroll>
          </MediaProvider>
          </ContentProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
